/**
 * Search works by title (and artist) on collection / vendor pages.
 * Filters the current grid instantly and searches the full collection via products.json.
 */
(function () {
  var page = document.querySelector("[data-coll-page]");
  if (!page) return;

  var input = page.querySelector("[data-work-search]");
  var clearBtn = page.querySelector("[data-work-search-clear]");
  var results = page.querySelector("[data-work-search-results]");
  var emptyEl = page.querySelector("[data-work-search-empty]");
  var countEl = page.querySelector("[data-coll-count]");
  var masonry = page.querySelector(".masonry");
  var pagination = page.querySelector("[data-coll-pagination]");
  var wrap = page.querySelector("[data-work-search-wrap]");
  var toggle = page.querySelector("[data-work-search-toggle]");
  var toggleLabel = page.querySelector("[data-work-search-toggle-label]");
  if (!input || !results || !masonry) return;

  // Path only — vendor collections often have collection.url with ?q=artist
  var productsBase = (page.getAttribute("data-coll-products-base") || "").trim();
  try {
    if (productsBase.indexOf("://") !== -1 || productsBase.charAt(0) === "/") {
      productsBase = new URL(productsBase, window.location.origin).pathname;
    } else if (productsBase.indexOf("?") !== -1) {
      productsBase = productsBase.split("?")[0];
    }
  } catch (e) {
    productsBase = productsBase.split("?")[0];
  }
  productsBase = productsBase.replace(/\/$/, "");
  if (!productsBase) {
    productsBase = window.location.pathname.replace(/\/$/, "");
  }

  var catalog = null;
  var catalogPromise = null;
  var baseCountText = countEl ? countEl.textContent : "";
  var timer = null;

  function norm(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function moneyFromCents(cents) {
    if (cents == null || !isFinite(Number(cents))) return "";
    try {
      return (Number(cents) / 100).toLocaleString(undefined, {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP"
      });
    } catch (e) {
      return "£" + (Number(cents) / 100).toFixed(2);
    }
  }

  function imageUrl(product) {
    var img = product && (product.images && product.images[0] || product.image);
    if (!img) return "";
    var src = typeof img === "string" ? img : img.src;
    if (!src) return "";
    if (src.indexOf("cdn.shopify.com") !== -1 && src.indexOf("width=") === -1) {
      return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=700";
    }
    return src;
  }

  function vendorQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      var q = (params.get("q") || "").trim();
      if (!q) return "";
      // Vendor pages: /collections/vendors?q=Artist%20Name
      if (productsBase.indexOf("/collections/vendors") !== -1) return q;
      return "";
    } catch (e) {
      return "";
    }
  }

  function normalizeSuggestProduct(p) {
    if (!p) return null;
    var handle = p.handle;
    if (!handle && p.url) {
      var m = String(p.url).match(/\/products\/([^/?#]+)/);
      handle = m ? m[1] : "";
    }
    var price =
      p.price_min != null
        ? p.price_min
        : p.price != null
          ? p.price
          : p.variants && p.variants[0]
            ? p.variants[0].price
            : null;
    // Suggest prices are usually cents (integers); keep as string cents for renderResults
    var variantPrice =
      price != null && String(price).indexOf(".") === -1
        ? String(price)
        : price != null
          ? String(Math.round(parseFloat(price) * 100))
          : null;
    return {
      title: p.title || "",
      vendor: p.vendor || "",
      handle: handle || "",
      image: p.image || (p.featured_image && p.featured_image.url) || "",
      images: p.images || [],
      variants: [{ price: variantPrice }]
    };
  }

  function catalogFromDom() {
    var cards = masonry.querySelectorAll(".mcard[data-work-handle]");
    var list = [];
    cards.forEach(function (card) {
      var handle = card.getAttribute("data-work-handle");
      if (!handle) return;
      var img = "";
      var ph = card.querySelector(".mcard-ph, [style*='background-image']");
      if (ph) {
        var bg = ph.style && ph.style.backgroundImage;
        if (bg) {
          var m = bg.match(/url\(["']?(.*?)["']?\)/);
          if (m) img = m[1];
        }
      }
      list.push({
        title: card.getAttribute("data-work-title") || "",
        vendor: card.getAttribute("data-work-vendor") || "",
        handle: handle,
        image: img,
        images: img ? [img] : [],
        variants: []
      });
    });
    return list;
  }

  async function loadVendorCatalog(vendor) {
    var q = 'vendor:"' + vendor.replace(/"/g, "") + '"';
    var url =
      "/search/suggest.json?q=" +
      encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=50&resources[options][fields]=title,vendor,product_type,tag";
    var res = await fetch(url, {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    });
    if (!res.ok) return catalogFromDom();
    var data = await res.json();
    var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    var list = products
      .map(normalizeSuggestProduct)
      .filter(function (p) {
        return p && p.handle && norm(p.vendor) === norm(vendor);
      });
    // Merge any on-page cards missing from suggest (pagination edge cases)
    catalogFromDom().forEach(function (domP) {
      if (
        !list.some(function (p) {
          return p.handle === domP.handle;
        })
      ) {
        list.push(domP);
      }
    });
    return list.length ? list : catalogFromDom();
  }

  async function loadCollectionCatalog() {
    var all = [];
    var pageNo = 1;
    var maxPages = 20;
    var params = new URLSearchParams(window.location.search);
    // Work search uses ?work=; strip Shopify preview noise from the JSON request
    ["work", "page", "_ab", "_fd", "_sc", "preview_theme_id", "pb"].forEach(function (key) {
      params.delete(key);
    });
    params.set("limit", "250");

    while (pageNo <= maxPages) {
      params.set("page", String(pageNo));
      var url = productsBase + "/products.json?" + params.toString();
      var res = await fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      });
      if (!res.ok) break;
      var data = await res.json();
      var products = (data && data.products) || [];
      if (!products.length) break;
      all = all.concat(products);
      if (products.length < 250) break;
      pageNo += 1;
      await new Promise(function (r) {
        setTimeout(r, 120);
      });
    }
    return all;
  }

  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    if (catalogPromise) return catalogPromise;

    catalogPromise = (async function () {
      var vendor = vendorQuery();
      // Shopify vendor collections don't expose products.json — use search + DOM fallback
      var all = vendor ? await loadVendorCatalog(vendor) : await loadCollectionCatalog();
      if (!all.length) all = catalogFromDom();
      catalog = all;
      return catalog;
    })().catch(function () {
      catalogPromise = null;
      return catalogFromDom();
    });

    return catalogPromise;
  }

  function syncToggle(query) {
    var q = String(query || "").trim();
    var open = wrap ? !wrap.hidden : false;
    if (toggle) {
      toggle.classList.toggle("is-open", open);
      toggle.classList.toggle("is-active", !!q);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.title = q ? ('Searching "' + q + '"') : "Search works by name";
    }
    if (toggleLabel) {
      toggleLabel.textContent = q ? "Searching" : "Search";
    }
  }

  function setPanelOpen(open, opts) {
    opts = opts || {};
    if (!wrap) return;
    wrap.hidden = !open;
    syncToggle(input.value);
    if (open && opts.focus !== false) {
      window.requestAnimationFrame(function () {
        input.focus();
        if (opts.select) input.select();
      });
    }
  }

  function setSearchMode(on) {
    page.classList.toggle("is-work-searching", on);
    if (pagination) {
      pagination.hidden = on;
      pagination.setAttribute("aria-hidden", on ? "true" : "false");
      if (on) pagination.setAttribute("inert", "");
      else pagination.removeAttribute("inert");
    }
  }

  function renderResults(matches, query) {
    results.innerHTML = "";
    if (!matches.length) {
      results.hidden = true;
      if (emptyEl) {
        emptyEl.hidden = false;
        var qEl = emptyEl.querySelector("[data-work-search-query]");
        if (qEl) qEl.textContent = query;
      }
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    var frag = document.createDocumentFragment();
    matches.forEach(function (product) {
      var href = "/products/" + product.handle;
      var img = imageUrl(product);
      var a = document.createElement("a");
      a.className = "work-search-card";
      a.href = href;
      a.innerHTML =
        '<span class="work-search-card-ph"></span>' +
        '<span class="work-search-card-meta">' +
        '<span class="work-search-card-title"></span>' +
        '<span class="work-search-card-artist"></span>' +
        '<span class="work-search-card-price"></span>' +
        "</span>";
      var ph = a.querySelector(".work-search-card-ph");
      if (img) {
        var alt =
          (product.title || "Art print") +
          (product.vendor ? " art print by " + product.vendor : " art print");
        ph.innerHTML = "";
        var imageEl = document.createElement("img");
        imageEl.src = img;
        imageEl.alt = alt;
        imageEl.loading = "lazy";
        ph.appendChild(imageEl);
      } else {
        ph.classList.add("a", "a-oat");
      }
      a.querySelector(".work-search-card-title").textContent = product.title || "";
      a.querySelector(".work-search-card-artist").textContent = product.vendor || "";
      var priceEl = a.querySelector(".work-search-card-price");
      var variant = product.variants && product.variants[0];
      var price = variant && (variant.price != null ? variant.price : null);
      // products.json price is often a string in major units, sometimes cents
      if (price != null) {
        var raw = String(price);
        if (raw.indexOf(".") !== -1) {
          priceEl.textContent = "from " + moneyFromCents(Math.round(parseFloat(raw) * 100));
        } else if (Number(raw) > 1000) {
          priceEl.textContent = "from " + moneyFromCents(Number(raw));
        } else {
          priceEl.textContent = "from " + moneyFromCents(Math.round(Number(raw) * 100));
        }
      }
      frag.appendChild(a);
    });
    results.appendChild(frag);
    results.hidden = false;
  }

  function filterPageCards(query) {
    var q = norm(query);
    var cards = masonry.querySelectorAll(".mcard");
    cards.forEach(function (card) {
      if (!q) {
        card.classList.remove("is-work-hidden");
        return;
      }
      var title = norm(card.getAttribute("data-work-title"));
      var vendor = norm(card.getAttribute("data-work-vendor"));
      var match = title.indexOf(q) !== -1 || vendor.indexOf(q) !== -1;
      card.classList.toggle("is-work-hidden", !match);
    });
  }

  function writeParam(query) {
    try {
      var url = new URL(window.location.href);
      if (query) url.searchParams.set("work", query);
      else url.searchParams.delete("work");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function apply(query) {
    var q = String(query || "").trim();
    if (clearBtn) clearBtn.hidden = !q;
    syncToggle(q);

    if (!q) {
      setSearchMode(false);
      filterPageCards("");
      results.hidden = true;
      results.innerHTML = "";
      if (emptyEl) emptyEl.hidden = true;
      if (countEl && baseCountText) countEl.textContent = baseCountText;
      writeParam("");
      return;
    }

    setSearchMode(true);
    filterPageCards(q);
    writeParam(q);
    if (countEl) countEl.textContent = "Searching…";

    loadCatalog().then(function (products) {
      if (norm(input.value) !== norm(q)) return;
      var nq = norm(q);
      var matches = products.filter(function (p) {
        return (
          norm(p.title).indexOf(nq) !== -1 ||
          norm(p.vendor).indexOf(nq) !== -1
        );
      });
      renderResults(matches, q);
      if (countEl) {
        countEl.textContent =
          matches.length +
          (matches.length === 1 ? " matching work" : " matching works");
      }
    });
  }

  // Seed from URL — open panel when a shared ?work= query is present
  try {
    var initial = new URLSearchParams(window.location.search).get("work") || "";
    if (initial) {
      input.value = initial;
      setPanelOpen(true, { focus: false });
      apply(initial);
    } else {
      syncToggle("");
    }
  } catch (e) {
    syncToggle("");
  }

  if (toggle && wrap) {
    toggle.addEventListener("click", function () {
      var willOpen = wrap.hidden;
      setPanelOpen(willOpen, { focus: willOpen, select: willOpen && !!input.value });
    });
  }

  input.addEventListener("input", function () {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      apply(input.value);
    }, 120);
  });

  input.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      if (input.value) {
        input.value = "";
        apply("");
        input.focus();
      } else {
        setPanelOpen(false);
        if (toggle) toggle.focus();
      }
    }
  });

  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      input.value = "";
      apply("");
      input.focus();
    });
  }

  var emptyClear = page.querySelector("[data-work-search-empty-clear]");
  if (emptyClear) {
    emptyClear.addEventListener("click", function () {
      input.value = "";
      apply("");
      setPanelOpen(true);
    });
  }
})();
